import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FADE_ANIMATION_IN, FLEX } from 'src/components/common/styles';

const NavbarContainer = styled.nav`
  grid-area: navbar;
  box-shadow: 4px 1px 6px 0 ${(p) => p.theme.BLACK_RGB_16};
  border-width: 0 0 1px 0;
  border-style: solid;
  border-color: ${(p) => p.theme.ALTO};
  background-color: #333333;
  will-change: opacity;
 
  //Custom Styling
  padding-left: 24px;
  padding-right: 24px;
  height: 70px;

  //To Make it Sticky
  z-index: 1000;
  position: fixed;
  top: 0;
  width: 100%;
`;

const NavbarWrapper = styled.div` 
  max-width: 1400px;
  margin: 0 auto;
  ${FLEX('center', 'space-between')};
  ${FADE_ANIMATION_IN};
  /* position: fixed;
  top: 0; */
  width: 100%;
  // padding-top: 24px;
  // padding-bottom: 20px;
`;


// Changed BG color for Nav

const NavbarLogoContainer = styled.a`
  max-width: 100%;
  max-height: 100%;
`;

const NavbarLogo = styled.img`
  max-width: 100%;
  max-height: 100%;
`;


const NavbarListItemContainer = styled.div`
  position: relative;
  ${FLEX('center')};
`;

const NavbarListItemDisplayImage = styled.img`
  height: 44px;
  width: 44px;
  border-radius: 50%;
  object-fit: contain;
`;

const NavbarListItemUserInformation = styled.div`
  padding-left: 16px;
`;

const NavbarListItem = styled.div`
  font-size: ${(p) => p.theme.MEDIUM};
  font-weight: ${(p) => p.theme.SEMI_BOLD_FONT};
  color: ${(p) => p.theme.TUNDORA};

  &:nth-child(2) {
    font-size: ${(p) => p.theme.SMALL};
    font-weight: ${(p) => p.theme.LIGHT_FONT};
  }
`;

const ActiveStateActiveJobs = styled(Link)`
  color: #F6F6F6;
  margin-left: 80px;
  margin-right: 20px;
  border-bottom: 5px solid #1ACEBC;
  text-decoration: none;
  padding-top: 27px;
  padding-bottom: 17px;
`;

const InactiveStateActiveJobs = styled(Link)`
  color: grey;
  margin-left: 80px;
  margin-right: 20px;
  padding-top: 24px;
  padding-bottom: 20px;
  text-decoration: none;
`;

const ActiveStateSearch = styled(Link)` 
  color: #F6F6F6;
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 5px solid #1ACEBC;
  text-decoration: none;
  padding-top: 27px;
  padding-bottom: 17px;
`;

const InactiveStateSearch = styled(Link)` 
  color: grey;
  margin-left: 20px;
  margin-right: 20px;
  padding-top: 24px;
  padding-bottom: 20px;
  text-decoration: none;
`;

const ActiveStateTracker = styled(Link)` 
  color: #F6F6F6;
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 5px solid #1ACEBC;
  text-decoration: none;
  padding-top: 27px;
  padding-bottom: 17px;
`;

const InactiveStateTracker = styled(Link)` 
  color: grey;
  margin-left: 20px;
  margin-right: 20px;
  padding-top: 24px;
  padding-bottom: 20px;
  text-decoration: none;
`;

const LogoutLink = styled.div`
  float: right;
  margin: 0px;
  color: #F6F6F6;
  cursor: pointer;
`;

export {
  NavbarContainer,
  NavbarWrapper,
  NavbarLogoContainer,
  NavbarLogo,
  NavbarListItemContainer,
  NavbarListItemDisplayImage,
  NavbarListItemUserInformation,
  NavbarListItem,
  ActiveStateActiveJobs,
  InactiveStateActiveJobs,
  ActiveStateSearch,
  InactiveStateSearch,
  ActiveStateTracker,
  InactiveStateTracker,
  LogoutLink,
};
